import React from 'react';
import PresentationToolbar from '@tencent/presentation-toolbar';
import { IPlayerEvent } from '@tencent/live-components';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWOperationType, TDWModuleType, TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import appConfigInstance, { setDefaultConfig } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { onLiveBarCallBack } from '../../roomEventHandler';
import { IPlayerState } from '../../common.interface';
import { DOC_TYPE, ROLE } from '../../message_const';
import ua from '@tencent/docs-user-agent';
import Aegis from '@src/slide/infrastructure/module/dependent/report/platform/aegis';

import '@tencent/presentation-toolbar/dist/style.css';
import { stopRecordRect } from '@src/utils/tencent-meeting';
import { ILiveManager } from '@src/slide/application/service/live-manager/core/interface';
import { TENANT_CONFIG } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import { getHandledTenantLogo } from '@src/slide/infrastructure/module/dependent/config/tob/utils';

interface ITencentMeetingLiveBarProps {
    currentPage: number;
    playerState: IPlayerState;
    liveManager: ILiveManager;
    docType: DOC_TYPE;
    padId: string;
    role: ROLE;
    isFullScreen: boolean;
}

interface State {
    isPresenterView: boolean;
}

const reportPresenter = (reportParam) => {
    tdw({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.PC_PLAY_PRESENTER,
        // FIXME:
        // 上报来源：2-远程播放，3-腾讯会议
        ver5: 3,

        ...reportParam,
    });
};

export default class TencentMeetingLiveBar extends React.Component<ITencentMeetingLiveBarProps, State> {
    public constructor(props) {
        super(props);

        this.state = {
            isPresenterView: ua.isPC && props.role === ROLE.MASTER,
        };
    }

    public componentDidMount() {
        this.reportForLiveBar(this.liveBarConfig());
    }

    /** 上报工具栏入口曝光 FIXME: 应该在组件中实现； */
    public reportForLiveBar = (liveBarConfig) => {
        if (liveBarConfig.toggleViewBtn) {
            reportPresenter({ action: TDWActionType.VIEW_SWITCH_PRESENTER });
        }
    };

    public render() {
        const { currentPage, playerState, liveManager, docType, padId, role, isFullScreen } = this.props;
        const { isPresenterView } = this.state;
        const { pageCount, laserTurnOn, enableAnnotation } = playerState;

        let fold: boolean | 'auto';
        if (isPresenterView) {
            // 1. 备注视图，始终不折叠
            fold = false;
        } else if (enableAnnotation) {
            // 2. 观众视图, 若批注工具栏也开启，为避免遮挡，演示工具栏始终折叠
            fold = true;
        } else {
            // 2. 观众视图, 若批注工具栏关闭，则根据屏幕宽度自适应
            fold = 'auto';
        }

        return <PresentationToolbar
            currentPage={currentPage}
            pageCount={pageCount}
            config={this.liveBarConfig()}
            laserTurnOn={laserTurnOn}
            liveDelegate={liveManager as any}
            eventCallBack={this.onLiveBarCallBack}
            docType={docType}
            padId={padId}
            role={+role}
            // TODO: move to playerState
            isFullScreen={isFullScreen}
            isPresenterView={isPresenterView}
            enableAnnotation={enableAnnotation}
            placement={isPresenterView ? 'top-right' : 'bottom-right'}
            autoTranslucent={!isPresenterView}
            fold={fold}
            style={
                isPresenterView
                    ? {
                        opacity: '1!important',
                        position: 'fixed',
                        top: 8,
                        right: 0,
                        background: 'none',
                        boxShadow: 'none',
                        transformOrigin: 'top right',
                        transform: 'scale(1.2)',
                    }
                    : undefined
            }
        />;
    }

    private async toggleView(event, flag, data, extra) {
        if (this.props.role !== ROLE.MASTER) return;

        reportPresenter({ action: TDWActionType.CLICK_SWITCH_PRESENTER });

        // 会议演示场景, 切换视图时暂停采集
        if (ua.isTencentMeeting) {
            await stopRecordRect();
        }

        this.setState({
            isPresenterView: !this.state.isPresenterView,
        });
        onLiveBarCallBack(event, flag, data, extra, this.props.liveManager);
    }

    private onLiveBarCallBack = (event, flag, data, extra) => {
        if (event === IPlayerEvent.ToggleView) {
            void this.toggleView(event, flag, data, extra);
            return;
        }

        onLiveBarCallBack(event, flag, data, extra, this.props.liveManager);

        switch (event) {
            case IPlayerEvent.Laser:
                if (this.state.isPresenterView) reportPresenter({ action: TDWActionType.POINTER_PRESENTER });
                break;

            case IPlayerEvent.Exit:
                if (this.state.isPresenterView) reportPresenter({ action: TDWActionType.EXIT_PRESENTER });
                break;

            case 'Annotation':
                Aegis.getInstance().aegis.reportEvent({ name: 'ANNOTATION_START' });
                break;
        }
    };

    private liveBarConfig() {
        const { docType } = this.props;
        const config = {
            showClock: false,
            showToolBar: setDefaultConfig(appConfigInstance.getConfig('custom.player.showToolBar'), true),
            pageTurnerBtn: docType !== DOC_TYPE.DOC && setDefaultConfig(appConfigInstance.getConfig('custom.player.pageTurnerBtn'), true),
            laserBtn: ua.isPC && setDefaultConfig(appConfigInstance.getConfig('custom.player.laserBtn'), true),
            annotationBtn: ua.isPC && setDefaultConfig(appConfigInstance.getConfig('custom.player.annotation'), true),
            toggleViewBtn: ua.isPC,
            fullScreenBtn: ua.isPC && setDefaultConfig(appConfigInstance.getConfig('custom.player.fullScreenBtn'), true),
            quitBtn: setDefaultConfig(appConfigInstance.getConfig('custom.player.quitBtn'), true),
            zoomIn: docType === DOC_TYPE.PDF,
            zoomOut: docType === DOC_TYPE.PDF,
            qrCodeIconUrl: getHandledTenantLogo(TENANT_CONFIG.TENANT_LOGO.SVG_COLOR),
        };

        if (this.state.isPresenterView) {
            config.showClock = true;
            config.pageTurnerBtn = false;
        }

        return config;
    }
}
